<h4 class="color-dark">
  <span class="add-btn ml-0" (click)="addRideMarketing(addRideMarketingModal, {})"> ADD NEW </span>
</h4>
<div class="custom-datatable marketing-configuration-table">
  <ng-container *ngIf="showLoader">
    <ngx-skeleton-loader animation="false" count="10" [theme]="{'width': '100%', 'height': '40px'}">
    </ngx-skeleton-loader>
  </ng-container>
  <ng-container *ngIf="!showLoader">
    <div class="marketing-table-scroll">
    <ngx-datatable [rows]="dataList" [scrollbarH]="true" class="bootstrap"
      [loadingIndicator]="loadingIndicator" [headerHeight]="32" [footerHeight]="45" [rowHeight]="'auto'"
      [columnMode]="ColumnMode.force" [reorderable]="reorderable">

      <ngx-datatable-column name="Image" [width]="120" [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="customerName">
            <span class="span-column">
              <img src="{{ row['image'] || './assets/images/user.png' }}" alt="marketing config">
            </span>
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="100" [resizeable]="false" name="order">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Order</span>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["order"] }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="180" [resizeable]="false" name="imageTitle">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Image Title</span>
          <div class="search">
            <input type="text" #imageTitle (input)="onSearch(imageTitle)" name="imageTitle" id="imageTitle"
              class="form-control search-bar" placeholder="{{ 'imageTitle' | translate }}" />
            <span class="filter" (click)="filter()"><img src="./../assets/images/filter-icon.svg" alt="Moniic" /></span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["imageTitle"] }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="180" [resizeable]="false" name="description">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Description</span>
          <div class="search">
            <input type="text" #description (input)="onSearch(description)" name="description" id="description"
              class="form-control search-bar" placeholder="{{ 'description' | translate }}" />
            <span class="filter" (click)="filter()"><img src="./../assets/images/filter-icon.svg" alt="Moniic" /></span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["description"] }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="180" [resizeable]="false" name="cta">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>CTA</span>
          <div class="search">
            <select #cta (change)="onSearch(cta)" name="cta" id="cta"
              class="form-control search-bar" [value]="onSearchValue('cta')">
              <option value="">ALL</option>
              <option value="OPEN_RIDE_NOW">OPEN_RIDE_NOW</option>
              <option value="OPEN_SCHEDULE">OPEN_SCHEDULE</option>
              <option value="OPEN_HOURLY">OPEN_HOURLY</option>
            </select>
            <span class="filter" (click)="filter()"><img src="./../assets/images/filter-icon.svg" alt="Moniic" /></span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["cta"] }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="120" [resizeable]="false" name="status">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Status</span>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["status"] || "ACTIVE" }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="180" [resizeable]="false" name="created-at">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Created On</span>
          <div class="search">
            <input type="date" #createdAt name="createdAt" id="createdAt" (input)="onSearch(createdAt)"
              class="form-control search-bar" placeholder=" {{ 'carsmanagement.search' | translate }}" />
            <span class="filter" (click)="filter()"><img src="./../assets/images/filter-icon.svg" alt="Moniic" /></span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["createdAt"] | dateTimeFormat }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="180" [resizeable]="false" name="updated-at">
        <ng-template let-column="column" ngx-datatable-header-template>
          <span>Last Update On</span>
          <div class="search">
            <input type="date" #updatedAt name="updatedAt" id="updatedAt" class="form-control search-bar"
              (input)="onSearch(updatedAt)" placeholder=" {{ 'carsmanagement.search' | translate }}" />
            <span class="filter" (click)="filter()"><img src="./../assets/images/filter-icon.svg" alt="Moniic" /></span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="span-column">
            {{ row["updatedAt"] | dateTimeFormat }}
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="180" [resizeable]="false" name="action" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-row="row">
          <span> Action </span>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="add-btn action-btn call-btn" (click)="addRideMarketing(addRideMarketingModal, row)" style="margin-right: 10px;">Edit
          </span>
          <span class="add-btn action-btn call-btn" (click)="deleteMarketingConfiguration(row)" style="background-color: #FF6060;">Delete
          </span>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>

    <div class="inner-content alignment" *ngIf="totalCount === 0">
      {{ "No record found" | translate }}
    </div>
    </div>

    <div class="customPagination" *ngIf="totalCount > 0">
      <ng-container>
        <div class="customPagination-left">
          <button class="btn btn-download" (click)="downloadFile()">
            {{'button.DownloadCSV' | translate}}
          </button>
          <div class="count-data">
            Showing
            <span>{{ (pageNumber - 1) * perPage + 1 }}-{{ pageNumber * perPage }}</span>
            of
            <span>{{ totalCount }} items.</span>
          </div>
        </div>
        <div class="customPagination-right" *ngIf="totalCount > 9">
          <ngb-pagination [collectionSize]="totalCount" [maxSize]="3" [pageSize]="perPage" [(page)]="pageNumber"
            (pageChange)="loadPage($event)">
            <ng-template ngbPaginationPrevious>{{'paginationContent.Previous' | translate}}</ng-template>
            <ng-template ngbPaginationNext>{{'paginationContent.Next' | translate}}</ng-template>
          </ngb-pagination>
          <input type="number" [(ngModel)]="inputPage" (keypress.enter)="onPageNumber($event)" max="{{maxNumber}}"
            NumericInput placeholder="Enter Page #" (blur)="onPageNumber($event)" (keydown.enter)="onPageNumber($event)"
            min="1">
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
<ng-template #addRideMarketingModal let-modal>
  <app-add-ride-marketing  [configurationData]="configurationData" (close)="closeForm()"></app-add-ride-marketing>
</ng-template>

<div *ngIf="loading">
  <div class="loader-span"></div>
</div>
